import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { LibFormContainerModule } from '../form-container/form-container.module';
import { MarkdownComponent } from './markdown.component';
import { MarkdownService } from './markdown.service';

@NgModule({
    imports: [CommonModule, MatCardModule, LibFormContainerModule],
    exports: [MarkdownComponent],
    declarations: [MarkdownComponent],
})
export class LibMarkdownModule {
    static forRoot(): ModuleWithProviders<LibMarkdownModule> {
        return {
            ngModule: LibMarkdownModule,
            providers: [MarkdownService],
        };
    }
}
